import {
  GET_CONTINUED_COUPONS_REQUEST,
  GET_CONTINUED_COUPONS_SUCCESS,
  GET_CONTINUED_COUPONS_FAILURE,
  RESET_CONTINUED_COUPONS_PAGINATION
} from 'Store/constants';

const initialState = {
  data: [],
  pagination: {
    pageSize: 15,
    pageIndex: 0,
    hasMore: null
  },
  isFetched: false,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTINUED_COUPONS_REQUEST:
      return { ...state, isFetched: false, isLoading: true, error: null };
    case GET_CONTINUED_COUPONS_SUCCESS:

      if (action.sharedCouponId) {
        state.data.map(coupon => {
          if (coupon.couponId === action.sharedCouponId) {
            coupon.isShared = true;
          }
          return coupon;
        });
      }

      return {
        data: [...state.data, ...action.payload],
        pagination: {
          ...action.pagination,
          hasMore: true
        },
        isFetched: true,
        isLoading: false,
        error: null
      };
    case GET_CONTINUED_COUPONS_FAILURE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          hasMore: false
        },
        isFetched: true,
        isLoading: false,
        error: action.payload
      };

    case RESET_CONTINUED_COUPONS_PAGINATION:
      return { ...state, pagination: initialState.pagination, data: [] };
    default:
      return state;
  }
};
